export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;
export const REQUEST_URL = `${BASE_URL}/${API_VERSION}/users/Questionnaire`;
export const CONTACT_URL = `${BASE_URL}/${API_VERSION}/landing/contact-us`;
